function normalizeString(s) {
  return s.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

export default normalizeString;
